import type {
  FetchOrganizationClientsArgs,
  FetchOrganizationUserById,
} from './types/user.types';
import type { ApiOrganizationClient } from '../schemas/organizationUser/organization.client.schema';
import type { BaseApiResponse } from './types/api.types';

import { mapOrganizationClientFromApi } from './mappers/organization.users.mappers';
import { postWithPagination, get } from './axios';

export async function fetchOrganizationClientById({
  id,
  organizationId,
}: FetchOrganizationUserById) {
  const response = await get<BaseApiResponse<ApiOrganizationClient>>(
    `/v2/organizations/${organizationId}/clients/${id}`,
  );
  return response?.data
    ? mapOrganizationClientFromApi(response.data)
    : undefined;
}

export async function fetchOrganizationClients({
  organizationId,
  ...body
}: FetchOrganizationClientsArgs) {
  const response = await postWithPagination<ApiOrganizationClient[]>(
    `/v2/organizations/${organizationId}/clients/list`,
    body,
  );

  return {
    ...response,
    data: response?.data?.map(mapOrganizationClientFromApi) ?? [],
    message: response?.message ?? '',
    status: response?.status ?? 200,
    total: response?.total ?? 0,
  };
}
